import { toast } from "@inno-ui/toast";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

import type { GetSmartSchedulingResponse } from "../../api/smart-scheduling/smart-scheduling.types";

import { getSmartScheduling } from "../../api/smart-scheduling/get-smart-scheduling";

export function useGetSmartScheduling() {
  const { t } = useTranslation();

  const { userToken } = useParams();
  if (!userToken) {
    toast.error({ title: t("User token is required") });
    return;
  }

  return useQuery<GetSmartSchedulingResponse>({
    queryKey: ["smart-scheduling", userToken],
    queryFn: () => getSmartScheduling(userToken),
    enabled: !!userToken,
  });
}
